// Shared sizing for the action/status rows rendered around the virtualised
// task list (previous-page, end-of-list, retry, loading).
export const ACTION_ROW_HEIGHT = 50;
// Breathing room after the final row, so the list does not end flush against the
// viewport edge. Only once there is genuinely nothing left to load: while more
// pages exist the last row should stay at the edge, where it trips the fetch.
export const END_OF_LIST_SPACER = 25;
// Below this many rows, scrolling back up is trivial and the link is clutter.
export const GO_TO_TOP_MIN_ROWS = 100;
